import { hydraUiApi } from '@/services/api';
import type { RolesRoleDefinitionsResponse } from '@customerio/hydra-ui-api';
import { getCrossAppCacheAsync, setCrossAppCache } from '@/utils/cross-app-cache';

export const getRoleDefinitions = async (accountId: number): Promise<RolesRoleDefinitionsResponse | null> => {
  const url = `/accounts/${accountId}/role_definitions`;
  const cachedRoleDefinitions = await getCrossAppCacheAsync(url);
  if (cachedRoleDefinitions != null) {
    // The cross-app cache is untyped; the entry is a role-definitions response.
    // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
    return cachedRoleDefinitions as RolesRoleDefinitionsResponse;
  }
  const request = hydraUiApi.roles.getRoleDefinitions({ params: { path: { account_id: String(accountId) } } });
  // Cache the request itself, so if we catch it halfway through, we can await for it instead of making a new request.
  setCrossAppCache({ key: url, value: request, ttl: 10000, isAsync: true });
  try {
    const data = await request;
    // Once it's complete, we can replace the request with the data.
    setCrossAppCache({ key: url, value: data, ttl: 10000 });
    return data;
  } catch (_error) {
    // If the request fails, we remove the request from the cache so we can try again.
    setCrossAppCache({ key: url, value: null });
    return null;
  }
};
